import { MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { Renderer_Order } from './Renderer_Order.js';
import { ModuleFE_Advisor_OrderGroup, ModuleFE_Advisor_Action, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { OrderPlacedSource } from '../../../../_analytics/types.js';
import { PopUp_OrderGroupSelector } from '../../../pop-ups/PopUp_OrderGroupSelector/PopUp_OrderGroupSelector.js';
export class Renderer_Order_Group extends Renderer_Order {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.disabled = ModuleFE_EMInterface.isReadonly();
        state.group = ModuleFE_Advisor_OrderGroup.cache.unique(nextProps.groupId);
        if (!state.group)
            throw new MUSTNeverHappenException(`Could not get order group for id ${nextProps.groupId}`);
        state.rtOrders = sortArray(nextProps.rtOrders, rtOrder => state.group.items.findIndex(pointer => pointer.id === rtOrder.orderId));
        return state;
    }
    //######################### Logic #########################
    getOrderIcon = undefined;
    getOrderLabel = () => `[${this.state.group.__orderIds.length}] ${this.state.group.name ?? this.state.group.label}`;
    getDisabled = () => this.state.disabled;
    getVariant = () => 'order-primary';
    onOrderClick = async (e) => {
        stopPropagation(e);
        const rtOrder = this.state.rtOrders[0];
        if (!rtOrder)
            return;
        await ModuleFE_RuntimeOrder.orderAll([rtOrder._id], undefined);
        const dbOrder = ModuleFE_Advisor_Action.cache.unique(rtOrder.orderId);
        ModuleFE_AdvisorAnalytics.trigger.orders.order_placed({
            orderId: rtOrder.orderId,
            orderLabel: dbOrder?.label ?? dbOrder?.name ?? this.state.group.label ?? this.state.group.name,
            source: OrderPlacedSource.suggestedWorkup,
        });
    };
    onContextMenu = (e) => {
        stopPropagation(e);
        PopUp_OrderGroupSelector.show(e, {
            group: this.state.group,
            rtOrders: this.state.rtOrders,
        });
    };
}
//# sourceMappingURL=Renderer_Order_Group.js.map